import {
  regex
} from 'vuelidate/lib/validators/common';
import { credentialsRegex, specialCharRegex, upperLowerRegex } from '@/constants';

const firstChar = regex('firstChar', /^[a-zA-Z0-9].*$/),
      validChars = regex('validChars', credentialsRegex),
      repeatingChars = regex('repeatingChars', /^((.)\2?(?!\2))*$/i),
      alphaNumeric = regex('alphaNumeric', /(?=.*[0-9])(?=.*[a-zA-Z]).+/),
      specialChar = regex('specialChar', specialCharRegex),
      upperLower = regex('upperLower', upperLowerRegex);

export {
  firstChar,
  validChars,
  repeatingChars,
  alphaNumeric,
  specialChar,
  upperLower
};